// extracted by mini-css-extract-plugin
export default {"icon":"PopoverWithCustomIcon_icon__e3GDX","active":"PopoverWithCustomIcon_active__VflF2"};